import React from 'react';
import { IceBlueBackdrop } from '../components/IceBlueBackdrop';
import { LeftDesignPanel } from '../components/LeftDesignPanel';
import { LoginForm } from '../components/LoginForm';
import { useLoginForm } from '../hooks/useLoginForm';

export const LoginPage = () => {
  const formProps = useLoginForm();

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 sm:p-6 lg:p-8 relative overflow-hidden" 
      style={{ fontFamily: "'DM Sans', sans-serif" }}
    >
      {/* Full-Page Ice Blue Fluid Waves Backdrop (Matches Reference Screenshot Colors) */}
      <IceBlueBackdrop />

      {/* Contained sharp luxury modular card */}
      <div className="w-full max-w-5xl bg-white rounded-none overflow-hidden shadow-[0_24px_80px_rgba(0,0,0,0.25)] flex flex-col lg:flex-row min-h-[640px] relative z-10">
        
        {/* Left premium modular kitchen backdrop column */}
        <LeftDesignPanel />

        {/* Right active credentials form column */}
        <LoginForm {...formProps} />

      </div>
    </div>
  );
};
